// react
import { ReactNode, useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// fields
import { Select } from '../Select/Select';

// mui
import { SelectProps as MuiSelectProps, SelectChangeEvent } from '@mui/material';

// types
import { Option } from '../../../@types';

export const SelectRowsPerPage = ({ defaultValue, label, onChange, ...props }: MuiSelectProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [value, setValue] = useState<string>(defaultValue ? defaultValue.toString() : '10');

	const optionsRowsPerPage: Option[] = [
		{
			label: '5',
			value: '5',
		},
		{
			label: '10',
			value: '10',
		},

		{
			label: '25',
			value: '25',
		},
		{
			label: '50',
			value: '50',
		},
	];

	const handleChange = (e: SelectChangeEvent<unknown>, child: ReactNode) => {
		if (onChange) {
			onChange(e, child);
		}

		setValue(e.target.value as string);
	};

	return (
		<Select
			aria-label={String(label) ? undefined : t('rowsPerPage')}
			defaultValue={defaultValue}
			hasNoneOption={false}
			hasSearchParam={true}
			label={label}
			name="limit"
			onChange={handleChange}
			options={optionsRowsPerPage}
			value={value}
			{...props}
		/>
	);
};
